import { createAction } from '@reduxjs/toolkit';

import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const generateVatReturnRequest = payload =>
  actionRequestFactory(types.GENERATE_VAT_RETURN_REQUEST, payload);
export const generateVatReturnSuccess = vatReturn =>
  actionResponseFactory(types.GENERATE_VAT_RETURN_SUCCESS, { vatReturn });
export const generateVatReturnFailure = error =>
  actionResponseFactory(types.GENERATE_VAT_RETURN_FAILURE, { error });

export const clearVatReturnData = () => actionRequestFactory(types.CLEAR_VAT_RETURN_DATA);

export const getVatReturnEntryListRequest = payload =>
  actionRequestFactory(types.GET_VAT_RETURN_ENTRY_LIST_REQUEST, payload);
export const getVatReturnEntryListSuccess = vatReturn =>
  actionResponseFactory(types.GET_VAT_RETURN_ENTRY_LIST_SUCCESS, { vatReturn });
export const getVatReturnEntryListFailure = error =>
  actionResponseFactory(types.GET_VAT_RETURN_ENTRY_LIST_FAILURE, { error });

export const downloadSAFTRequest = createAction(types.DOWNLOAD_SAFT_REQUEST);
export const downloadOfficialXmlRequest = createAction(types.DOWNLOAD_OFFICIAL_XML_REQUEST);
export const downloadVatReturnRequest = createAction(types.DOWNLOAD_VAT_RETURN_REQUEST);
export const downloadFiledReturnRequest = createAction(types.DOWNLOAD_FILED_RETURN_REQUEST);

export const downloadSuccess = createAction(types.DOWNLOAD_SUCCESS);
export const downloadFailure = createAction(types.DOWNLOAD_FAILURE);

export const sendVatReturnEmailRequest = payload =>
  actionRequestFactory(types.SEND_VAT_RETURN_EMAIL_REQUEST, payload);
export const sendVatReturnEmailSuccess = vatReturn =>
  actionResponseFactory(types.SEND_VAT_RETURN_EMAIL_SUCCESS, { vatReturn });
export const sendVatReturnEmailFailure = error =>
  actionResponseFactory(types.SEND_VAT_RETURN_EMAIL_FAILURE, { error });

export const getVatReturnBankDetailsRequest = payload =>
  actionRequestFactory(types.GET_VAT_RETURN_BANK_DETAILS_REQUEST, payload);
export const getVatReturnBankDetailsSuccess = bankDetails =>
  actionResponseFactory(types.GET_VAT_RETURN_BANK_DETAILS_SUCCESS, { bankDetails });
export const getVatReturnBankDetailsFailure = error =>
  actionResponseFactory(types.GET_VAT_RETURN_BANK_DETAILS_FAILURE, { error });

export const getCzechEconomicActivityListRequest = payload =>
  actionRequestFactory(types.GET_CZECH_ECONOMIC_ACTIVITY_LIST_REQUEST, payload);
export const getCzechEconomicActivityListSuccess = economicActivityList =>
  actionResponseFactory(types.GET_CZECH_ECONOMIC_ACTIVITY_LIST_SUCCESS, { economicActivityList });
export const getCzechEconomicActivityListFailure = error =>
  actionResponseFactory(types.GET_CZECH_ECONOMIC_ACTIVITY_LIST_FAILURE, { error });

export const getItalyVatReturnListRequest = payload =>
  actionRequestFactory(types.GET_ITALY_VAT_RETURN_ENTRY_LIST_REQUEST, payload);
export const getItalyVatReturnListSuccess = vatReturn =>
  actionResponseFactory(types.GET_ITALY_VAT_RETURN_ENTRY_LIST_SUCCESS, { vatReturn });
export const getItalyVatReturnListFailure = error =>
  actionResponseFactory(types.GET_ITALY_VAT_RETURN_ENTRY_LIST_FAILURE, { error });
